import React from 'react'
import { CheckCircleFill } from 'react-bootstrap-icons'
import ResponsivePopover from '@/components/molecules/ResponsivePopover/ResponsivePopover'
import PublisherHeaderTooltip from './PublisherHeaderTooltip'
import BlogPublisherName from './BlogPublisherName'
const BlogPublisherInfo = ({
  publishDate,
  authorData,
  reviewerData,
  noDate
}) => {
  const isValidReviewerData =
    reviewerData && reviewerData.slug && reviewerData.fullName

  return (
    <>
      {authorData && (
        <div className="flex flex-col flex-wrap items-start justify-start gap-3 text-gray-800 lg:flex-row lg:items-center">
          <div className="flex flex-col gap-3 lg:flex-row">
            <div className="flex flex-row items-center justify-start gap-3">
              <span>By</span>
              <ResponsivePopover
                header={
                  <PublisherHeaderTooltip
                    type="Author"
                    publisherData={authorData}
                  />
                }
                description={authorData.miniBlurb}
                buttonText="View Author Profile"
                buttonLink={`/author/${authorData.slug}/`}
                buttonType="tertiary"
              >
                <div className="flex flex-row items-center justify-start gap-2">
                  {authorData.slug && (
                    <img
                      src={`https://res.cloudinary.com/rehabpath/image/upload/v1655327781/${authorData?.slug}-circular-headshot.jpg`}
                      className="size-6 rounded-md"
                    />
                  )}
                  <BlogPublisherName authorData={authorData} />
                </div>
              </ResponsivePopover>
            </div>

            {!noDate && (
              <div className="flex flex-row items-center justify-start gap-3">
                <span className="hidden lg:block">|</span>
                <span>Published {publishDate}</span>
              </div>
            )}
          </div>
          {isValidReviewerData && (
            <>
              <div className="flex flex-row flex-wrap items-center justify-start gap-1">
                Clinically Reviewed by{' '}
                <div className="flex flex-row items-center justify-start gap-1">
                  <ResponsivePopover
                    header={
                      <PublisherHeaderTooltip
                        type="Reviewer"
                        publisherData={reviewerData}
                      />
                    }
                    description={reviewerData.miniBlurb}
                    buttonText="View Author Profile"
                    buttonLink={`/author/${reviewerData.slug}/`}
                    buttonType="tertiary"
                  >
                    <BlogPublisherName authorData={reviewerData} />
                  </ResponsivePopover>
                  <CheckCircleFill
                    size={12}
                    className="text-gray-1100"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  )
}

export default BlogPublisherInfo
